<div class="jinni" [ngClass]="{'active' : showGentle}" #login></div>
<div class="container login">
  <div class="welcomeText">{{'login.welcomeback' | translate}}</div>
  <div class="closeModal" (click)="closeLogin();"></div>
  <form [formGroup]="loginForm" (ngSubmit)="logIn(loginForm.value)">
    <div class="inputBox">
      <div class="singleInput">
        <label>{{'login.linput1' | translate}}</label>
        <input id="email" type="text" formControlName="email" [(ngModel)]="emailValueFromInput" placeholder="{{'login.ee' | translate}}" class="inputClass"
               (mouseover)="showTooltip($event, tooltipMessageEmail, (checkEmailField() || emailError));"
               (mouseout)="hideTooltip(); removeAllSpaces();"
               (focusout)="focusOutEmail(); removeAllSpaces();"
               [ngClass]="{'error': emailError}"
        />
        <span class="validIcon"></span>
          <span *ngIf="emailError" class="errorOnMobile">{{ 'login.lerror' | translate }}</span>
      </div>
      <div class="singleInput">
      <label>{{'login.linput2' | translate}}</label>
      <span class="fyp" (click)="resetPassword();">{{'login.fyp' | translate}}</span>
      <input id="password" type="password" formControlName="password" placeholder="{{'login.ep' | translate}}" class="inputClass"
             (mouseover)="showTooltip($event, tooltipMessagePassword, (checkPasswordField() || passwordError));"
             (mouseout)="hideTooltip(); "
             (focusout)="focusOutPassword();"
             [ngClass]="{'error': passwordError}"
      />
      <span class="validIcon"></span>
          <span *ngIf="passwordError" class="errorOnMobile">{{ 'login.lperror' | translate }}</span>
      </div>
    </div>
<div class="bottomButton">
  <button type="submit" class="przycisk green big btn btn-rounded btn-with-arrow btn-big2 btn-green btn-login" [disabled]="isLoadingButton" [ngClass]="{'success': loginForm.valid, 'disabled-btn' : isLoadingButton}">
    {{ 'login.lbtn' | translate }}<span *ngIf="isLoadingButton" class="spinner"></span>
  </button>
  <app-jinni-errors-messages [close]="close"></app-jinni-errors-messages>
</div>
  </form>
  <div class="registerText">
    <span class="text">{{'login.r1' | translate}} </span> <span class="create" (click)="goToRegistration();">{{'login.r2' | translate}}</span>
  </div>
</div>
